import BaseModel from "../base/baseModel";
import TipoObservacao from "../enum/tipoObservacao";

export default class ProdutoObservacoesModel extends BaseModel {
    id?: number = null;
    tipo?: TipoObservacao = null;
    tipoDescricao: string = null;
    texto: string = null;
}